module.exports = __webpack_public_path__ + "static/media/checkin_icon.6f9d3aa4.png";